import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function NoResultsFolded(props: SvgIconProps) {
  return (
    <SvgIcon height="129" viewBox="0 0 160 129" width="160" {...props}>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint0_linear_29782:91155"
          x1="109.469"
          x2="59.3853"
          y1="4.36919"
          y2="112.812"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint1_linear_29782:91155"
          x1="70.3999"
          x2="35.7398"
          y1="46.4015"
          y2="59.3212"
        >
          <stop stopColor="#F2F3F9" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint2_linear_29782:91155"
          x1="127.916"
          x2="84.615"
          y1="45.136"
          y2="62.2844"
        >
          <stop stopColor="#F2F3F9" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint3_linear_29782:91155"
          x1="78.5033"
          x2="33.1096"
          y1="130.412"
          y2="114.828"
        >
          <stop stopColor="#F2F3F9" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint4_linear_29782:91155"
          x1="96.7915"
          x2="96.7915"
          y1="90.0681"
          y2="97.4559"
        >
          <stop stopColor="#EEF3FB" />
          <stop offset="1" stopColor="#BECDEA" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint5_linear_29782:91155"
          x1="96.1667"
          x2="109.693"
          y1="102.97"
          y2="116.496"
        >
          <stop stopColor="#F2F3F9" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="noResultsFolded-paint6_linear_29782:91155"
          x1="61.692"
          x2="86.9411"
          y1="80.2178"
          y2="105.467"
        >
          <stop stopColor="#F2F3F9" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
      </defs>

      <path
        d="M135.344 16.3866C104.052 0.480203 94.5722 29.9128 57.1622 7.18566C23.78 -13.0981 8.43512 15.0217 4.10241 24.5499C-1.23443 36.2873 -6.72377 60.2827 24.9552 77.394C56.199 94.2711 56.861 116.065 90.5408 126.415C117.545 134.712 146.345 109.106 156.829 81.7714C163.572 64.1951 160.939 29.3959 135.344 16.3866Z"
        fill="url(#noResultsFolded-paint0_linear_29782:91155)"
      />

      <path
        clipRule="evenodd"
        d="M64.0884 71.653L41.6782 89.7724C39.8112 91.2822 37 89.9765 37 87.5998V35.7499C37 33.9475 37.8203 32.2391 39.2365 31.0942L64.0884 11V71.653Z"
        fill="url(#noResultsFolded-paint1_linear_29782:91155)"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M118.045 16.682V68.5316C118.045 70.3345 117.224 72.0424 115.808 73.1878L90.9565 93.2816V32.6289L113.366 14.5087C113.917 14.0634 114.55 13.8633 115.169 13.8633C116.647 13.8637 118.045 15.0066 118.045 16.682Z"
        fill="url(#noResultsFolded-paint2_linear_29782:91155)"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M91.1768 32.887V93.4965L64.0884 71.6099V11L91.1768 32.887Z"
        fill="url(#noResultsFolded-paint3_linear_29782:91155)"
        fillRule="evenodd"
      />

      <path
        d="M96.7915 92.899L99.6227 90.0681L104.179 94.6249L101.348 97.4559L96.7915 92.899Z"
        fill="url(#noResultsFolded-paint4_linear_29782:91155)"
      />

      <path
        clipRule="evenodd"
        d="M99.8696 99.2672L110.335 109.732C112.026 111.422 114.766 111.422 116.456 109.732C118.146 108.043 118.146 105.302 116.456 103.612L105.99 93.1462L99.8696 99.2672Z"
        fill="url(#noResultsFolded-paint5_linear_29782:91155)"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M74.3169 67.5933C67.3442 74.5656 67.3442 85.87 74.3169 92.8423C81.2888 99.8145 92.5932 99.8145 99.5659 92.8423C106.538 85.87 106.538 74.5656 99.5659 67.5933C96.0796 64.107 91.5102 62.364 86.9412 62.364C82.3719 62.364 77.8029 64.107 74.3169 67.5933Z"
        fill="url(#noResultsFolded-paint6_linear_29782:91155)"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default NoResultsFolded
